<div class="saas-ui date-picker-wrapper">
  <label (click)="toggleCalendar($event)" class="date-range-label">
    {{ label() }}
    <div class="input-wrapper">
      <input
        #calendarInput
        type="text"
        class="form-control form-control-sm"
        [class.compare-width]="compareToggledOn"
        [value]="getDatePickerLabel()"
        readonly />
      <i
        class="material-symbols-outlined calendar-icon text-blue-600"
        aria-hidden="true">
        calendar_today
      </i>
    </div>
  </label>
  @if (compareEnabled) {
    <label class="ms-3 compare" for="compareSwitchOutside">
      Compare
      <p-inputSwitch
        id="compareSwitchOutside"
        class="compare-switch mt-1"
        [(ngModel)]="compareToggledOn"
        (onChange)="onOutsideCompareToggle($event.checked)">
      </p-inputSwitch>
    </label>
  }
</div>

<p-dialog
  [(visible)]="showCalendar"
  appendTo="body"
  styleClass="date-picker-popup fiscal-calendar-popup"
  [showHeader]="false"
  [modal]="true"
  [focusOnShow]="false"
  [focusTrap]="true"
  (onShow)="onDialogShow()"
  (onHide)="cancel()"
  transitionOptions="0ms">
  <div #calendarPopup class="date-picker-popup-content">
    <!-- Left Side Panel -->
    <div
      class="left-side saas-ui saas-ui-size-default"
      [class.compare]="compareToggledOn">
      <!-- Header -->
      <div class="date-picker-header">
        <span class="sh2 text-gray-1000">Date Presets</span>
        <div class="flex gap-2 mt-2 items-center">
          <i
            class="material-symbols-outlined icon-small text-gray-500"
            aria-hidden="true">
            info
          </i>
          <span class="c1 text-gray-800">{{ availabilityInfoText }}</span>
        </div>
      </div>

      <!-- Current Period Date Inputs -->
      <div class="date-section">
        <div class="from-side">
          <label class="input-label">
            From
            <input
              pInputText
              type="text"
              class="date-input"
              [value]="displayDates().start"
              (focus)="onInputFocus($event, 'startDate')"
              (blur)="onInputBlur($event, 'startDate')"
              (change)="onInputChange($event, 'startDate')" />
          </label>
        </div>
        <div class="to-side">
          <label class="input-label">
            To
            <input
              pInputText
              type="text"
              class="date-input"
              [value]="displayDates().end"
              (focus)="onInputFocus($event, 'endDate')"
              (blur)="onInputBlur($event, 'endDate')"
              (change)="onInputChange($event, 'endDate')" />
          </label>
        </div>
      </div>

      <!-- Compare Section -->
      <div
        class="date-section"
        [class.compare]="compareToggledOn && compareEnabled">
        @if (compareEnabled) {
          <div class="input-switch">
            <label for="compareSwitch">
              <p-inputSwitch
                id="compareSwitch"
                class="compare-toggle"
                [(ngModel)]="compareToggledOn"
                (onChange)="compareToggledOn = $event.checked">
              </p-inputSwitch>
              <span class="toggle-text">Compare with</span>
            </label>
          </div>
        }
        @if (compareToggledOn && compareEnabled) {
          <div class="from-side">
            <label class="input-label">
              From
              <input
                pInputText
                type="text"
                class="date-input"
                [value]="displayDates().prevStart"
                (focus)="onInputFocus($event, 'startDateCompare')"
                (blur)="onInputBlur($event, 'startDateCompare')"
                (change)="onInputChange($event, 'startDateCompare')" />
            </label>
          </div>
          <div class="to-side">
            <label class="input-label">
              To
              <input
                pInputText
                type="text"
                class="date-input"
                [value]="displayDates().prevEnd"
                (focus)="onInputFocus($event, 'endDateCompare')"
                (blur)="onInputBlur($event, 'endDateCompare')"
                (change)="onInputChange($event, 'endDateCompare')" />
            </label>
          </div>
        }
      </div>

      <!-- Footer -->
      <div class="date-picker-footer d-flex gap-3 mt-auto">
        <m-button type="primary" label="Save" (click)="apply()"></m-button>
        <m-button type="secondary" label="Cancel" (click)="cancel()"></m-button>
      </div>
    </div>

    <!-- Right Side - Fiscal Calendar -->
    <div class="calendar-side fiscal">
      @if (showCalendar) {
        <m-fiscal-calendar
          [months]="months()"
          [startDate]="calendarDates().start"
          [endDate]="calendarDates().end"
          [previousStartDate]="
            compareToggledOn ? calendarDates().compareStart : null
          "
          [previousEndDate]="
            compareToggledOn ? calendarDates().compareEnd : null
          "
          [minDate]="formattedMinDate()"
          [maxDate]="formattedMaxDate()"
          (selectedDateRange)="onFiscalDateSelected($event)">
        </m-fiscal-calendar>
      }
    </div>
  </div>
</p-dialog>
